import React from "react";
import PropTypes from "prop-types";
import { Loader } from "components/Loader";
import {
  Wrapper,
  BarsRow,
  Bar,
  CardsRow,
  AssetCard,
  AssetName,
  AssetPct,
  LoaderWrapper,
} from "./AssetAllocationBars.styles";

const AssetAllocationBars = ({ assets = [], isLoading = false }) => {
  if (isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  if (!assets.length) return null;

  return (
    <Wrapper>
      <BarsRow>
        {assets.map((asset) => {
          const width = parseFloat(asset.percentage.replace("%", ""));
          return (
            <Bar
              key={asset.symbol || asset.name || asset.id}
              $width={width}
              $color={asset.color}
            />
          );
        })}
      </BarsRow>

      <CardsRow>
        {assets.map((asset) => (
          <AssetCard
            key={asset.symbol || asset.name || asset.id}
            $color={asset.color}
          >
            <AssetName>
              {asset.symbol || asset.name || asset.id || "N/A"}
            </AssetName>
            <AssetPct>{asset.percentage}</AssetPct>
          </AssetCard>
        ))}
      </CardsRow>
    </Wrapper>
  );
};

AssetAllocationBars.propTypes = {
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      percentage: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
    })
  ),
  isLoading: PropTypes.bool,
};

export default AssetAllocationBars;
